// Error processor (core, no browser specifics)
export class CoreErrorProcessor {
  constructor() {}
  // ...core error normalization, stack trace parsing
}
